import React from 'react';
import { Divider as MuiDivider } from '@mui/material';

const Divider = () => {
  return <MuiDivider />;
};

export default Divider;